const Query = props => {
  const { artworksV2 } = props || {};
  const { sqlQuery } = artworksV2 || {};

  return <div>{sqlQuery}</div>;
};

export default Query;
